import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/farbcode-logo.svg")